import React from "react";
import PlanForm from "./PlanForm";
import axios from "axios";
import { toast } from "react-toastify";
import { BACKEND_BASE_URL } from "../../config";

const API_BASE_URL = `${BACKEND_BASE_URL}/api`;

const CreatePlan = ({ onSuccess, onCancel }) => {
  const token = localStorage.getItem("authToken");

  const handleCreate = async (data) => {
    try {
      await axios.post(
        `${API_BASE_URL}/subscription/create/`,
        data,
        {
          headers: {  
            Authorization: `Bearer ${token}`,
          },
        }
      );
      toast.success("Plan created successfully!");
      onSuccess();
    } catch (error) {
      console.error("Error creating plan:", error);
      toast.error("Failed to create plan. Please try again.");
    }
  };

  return (
    <PlanForm
      initialData={{}}
      onSubmit={handleCreate}
      onCancel={onCancel}
    />
  );
};

export default CreatePlan;
